export const FormatDate = (dateTimes) => {
     const date = new Date(dateTimes);

     const day = date.getDate().toString().padStart(2, "0"); 
     const month = date.toLocaleString("fr-FR", { month: "short" });
     const year = date.getFullYear();
     const hours = date.getHours();
     const minutes = date.getMinutes().toString().padStart(2, "0");

     return `${day} ${month} ${year} à ${hours}h${minutes}`;
};

export const daysRemaining = (value) => {
    if(value) {
      const currentDate = new Date();
      const diffInMilliseconds = new Date(value) - currentDate;
      const diffInDays = diffInMilliseconds / (1000 * 3600 * 24);
      const dateEnd = Math.ceil(diffInDays);
      return dateEnd;
    }
    return null;
  }

  export const freeSubscription = (value) => {
    if(value) {
      const dateString = value.date ?? value ;
  
      const normalized = dateString.replace(' ', 'T');
      const startDate = new Date(normalized);
  
      const expirationDate = new Date(startDate);
      expirationDate.setDate(expirationDate.getDate() + 14);
  
      const now = new Date();
      const timeDiff = expirationDate - now;
      const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24))
  
      return daysRemaining > 0 ? daysRemaining : 0;
    }
    return 0;
  }

  // Export a function to set a date to 23:59 and return ISO string
export function safeDate(date) {
  if (date instanceof Date) {
    const end = new Date(date);
    end.setHours(23, 59, 0, 0);
    return end.toISOString();
  }
  return null;
}